import styled from 'styled-components';
import { palette } from 'styled-tools';

import { TextButton } from '@calm-web/design-system';

export const Wrapper = styled.div`
	width: 100%;
`;

export const Cta = styled(TextButton)`
	color: ${palette('blue3')};
	margin-left: 10px;
`;
